import React from 'react';
import { bool, node, number } from 'prop-types';
import { StickyWithHeaderObserver } from '@thd-olt-component-react/sticky';

export const AssistantWithPortal = ({ children, isMobile, offset }) => (isMobile ? (
  <StickyWithHeaderObserver
    className="sui-w-full"
    position="bottom"
    stickyByDefault
    visibleByDefault
    offsetMargin={offset}
  >
    {children}
  </StickyWithHeaderObserver>
) : (
  <>
    {children}
  </>
));

AssistantWithPortal.displayName = 'AssistantWithPortal';

AssistantWithPortal.propTypes = {
  children: node.isRequired,
  isMobile: bool.isRequired,
  offset: number.isRequired,
};
